import { Component, OnInit } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { GoogleAnalyticsService } from 'ngx-google-analytics';

@Component({
  selector: 'app-apresentacao',
  templateUrl: './apresentacao.component.html',
  styleUrls: ['./apresentacao.component.scss']
})

export class ApresentacaoComponent implements OnInit {
  data: any;

  constructor(
    private translate: TranslateService,
    private titleService: Title,
    private meta: Meta,
    private router: Router,
    private gaService: GoogleAnalyticsService
  ) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.carregarDados();
    });
  }

  ngOnInit() {
    this.carregarDados();
  }

  carregarDados() {
    this.translate.get('APRESENTACAO').subscribe(res => {
      this.data = res;
      this.titleService.setTitle(this.data.HEADER_TITLE);
      this.meta.updateTag({ name: 'description', content: this.data.META_DESCRIPTION });
      this.meta.updateTag({ name: 'keywords', content: this.data.META_KEYWORDS });
      this.gaService.pageView(this.router.url);
    });
  }

}
